import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import Button from '../button/Button'
import { faChevronDown, faChevronUp, faTrash } from '@fortawesome/free-solid-svg-icons'
import clsx from 'clsx'
import { toast } from 'react-toastify'
import { ParseErrors } from '../../utils/parse-errors'
import axiosInstance from '../../utils/axios-instance'
import SuretyModel from '../../models/surety-model'

const SingleUser = ({ item: itemData, className }: any) => {
    const [item, setItem] = useState(itemData)
    const [values, setValues] = useState({})
    const [expanded, setExpanded] = useState<boolean>(false)
    const [loading, setLoading] = useState(false)
    const [deletePopup, setDeletePopup] = useState(false)


    // --------------------------------- [ UPDATE USER ] ------------------------------------------------------------------
    const UpdateUser = async () => {
        setLoading(true)
        try {
            await axiosInstance.patch(`/user/update/user/${item.id}`, values)
            toast.success("User updated successfully")
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
            toast.error(ParseErrors(error))
        }
    }


    const DeleteUser = async () => {
        setLoading(true)
        try {
            await axiosInstance.delete(`/user/delete/user/${item.id}`)
            setItem(null)
            toast.success("User deleted successfully")
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
            toast.error(ParseErrors(error))
        }
    }


    const ToggleDeletePopup = () => {
        setDeletePopup(!deletePopup)
    }


    if (!item?.id) {
        return null
    }

    const inputClass = "h-[44px] w-full border border-gray-200 rounded-xl outline-none px-4 text-[14.5px] font-normal placeholder-gray-400 bg-white";

    return (
        <div className={clsx("w-full cursor-pointer border border-gray-100 bg-white rounded-2xl overflow-hidden hover:shadow-soft transition-shadow", className)}>
            <div
                className={clsx("w-full flex items-center justify-between p-4 transition-colors", expanded && "bg-gray-50")}
                onClick={() => setExpanded(!expanded)}
            >
                <div className="flex items-center justify-start">
                    <div className="h-11 w-11 rounded-full bg-blue/10 flex items-center justify-center mr-3 ring-2 ring-blue/5">
                        <span className="text-blue font-medium uppercase text-sm">{item?.name?.slice(0, 2)}</span>
                    </div>
                    <div>
                        <h2 className="text-[15px] font-medium capitalize text-lightBlack">{item?.name}</h2>
                        <p className="text-xs text-gray-500">{item?.email}</p>
                    </div>
                </div>
                <FontAwesomeIcon icon={expanded ? faChevronUp : faChevronDown} className={clsx("text-sm text-gray-400 transition-transform", expanded && "text-blue")} />
            </div>

            {expanded && (
                <div className="w-full p-5 border-t border-gray-100">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="text-[13px] font-medium text-lightBlack mb-1.5 block">Full Name</label>
                            <input
                                placeholder="User Name"
                                onChange={(e) => setValues((prev) => ({ ...prev, name: e.target.value }))}
                                defaultValue={item?.name}
                                className={`${inputClass} capitalize`}
                            />
                        </div>
                        <div>
                            <label className="text-[13px] font-medium text-lightBlack mb-1.5 block">Email</label>
                            <input
                                placeholder="Email"
                                onChange={(e) => setValues((prev) => ({ ...prev, email: e.target.value }))}
                                defaultValue={item?.email}
                                className={inputClass}
                            />
                        </div>
                    </div>

                    <div className="w-full flex items-center justify-between mt-5 gap-3">
                        <div className="w-auto">
                            <Button isLoading={loading} disabled={loading} onClick={UpdateUser} className="!w-auto !px-6">Update</Button>
                        </div>
                        <button
                            className="h-10 w-10 rounded-xl bg-red-50 text-red-500 hover:bg-red-100 flex items-center justify-center transition"
                            onClick={ToggleDeletePopup}
                            aria-label="Delete user"
                        >
                            <FontAwesomeIcon icon={faTrash} className="text-sm" />
                        </button>
                    </div>
                </div>
            )}

            {deletePopup ? <SuretyModel toggleModel={ToggleDeletePopup} onClick={DeleteUser} isLoading={loading} /> : null}
        </div>
    )
}

export default SingleUser
